import React from 'react';
import styled from '@emotion/styled';

import { DiscountInfo, ProductPrice } from '@domains/pdp-common';

import { DiscountPriceTag } from './Discount/DiscountPriceTag';
import { PriceInfo } from './PriceInfo/PriceInfo';
import { StyledPriceTag } from './StyledPriceTag';

interface Props {
  productPrice: ProductPrice;
  discountInfo: DiscountInfo | null;
  displayPriceLine: number;
  isVisibleDiscountDetailButton: boolean;
  onClickInfo: (children: React.ReactNode) => void;
}
export const Price: React.FC<React.PropsWithChildren<Props>> = ({
  productPrice,
  discountInfo,
  displayPriceLine,
  isVisibleDiscountDetailButton,
  onClickInfo,
}) => {
  const displayFinalPrice = productPrice.display_final_price;
  const maxPriceInfo = productPrice.max_price_info;
  const hasDiscountRate = displayFinalPrice.discount_rate > 0;
  const hasAdditionalFinalPrice = Boolean(displayFinalPrice?.final_price_additional?.price);

  const handleClickInfo = () => {
    onClickInfo(
      <BottomSheetContent>
        <PriceInfo productPrice={productPrice} discountInfo={discountInfo} />
      </BottomSheetContent>,
    );
  };

  return (
    <Wrap>
      {hasDiscountRate && (
        <DiscountPriceTag
          discountRateColor={displayFinalPrice.discount_rate_color.normal ?? ''}
          discountPriceColor={maxPriceInfo.color.normal ?? ''}
          discountRate={displayFinalPrice.discount_rate}
          discountPrice={maxPriceInfo.price}
        />
      )}
      <StyledPriceTag
        priceColor={displayFinalPrice.final_price.color.normal ?? ''}
        price={displayFinalPrice.final_price.price}
        currency={displayFinalPrice.final_price.price_with_currency.display_currency}
        text={hasAdditionalFinalPrice ? '' : displayFinalPrice.final_price.badge?.text}
        textColor={hasAdditionalFinalPrice ? '' : (displayFinalPrice.final_price.badge?.color?.normal ?? '')}
        onClickInfo={!hasAdditionalFinalPrice && isVisibleDiscountDetailButton ? handleClickInfo : undefined}
      />
      {hasAdditionalFinalPrice && (
        <Additional displayPriceLine={displayPriceLine}>
          <StyledPriceTag
            price={displayFinalPrice.final_price_additional?.price ?? 0}
            priceColor={displayFinalPrice.final_price_additional?.color.normal ?? ''}
            text={displayFinalPrice.final_price_additional?.badge?.text}
            textColor={displayFinalPrice.final_price_additional?.badge?.color?.normal ?? ''}
            currency={displayFinalPrice.final_price_additional?.price_with_currency.display_currency ?? ''}
            onClickInfo={isVisibleDiscountDetailButton ? handleClickInfo : undefined}
          />
        </Additional>
      )}
    </Wrap>
  );
};

const Wrap = styled.div`
  max-height: 67px;
`;
const Additional = styled.div<{ displayPriceLine: number }>`
  ${({ displayPriceLine }) => {
    if (displayPriceLine === 3) {
      return `
        position: relative;
        top: -2px;
      `;
    }
  }}
`;

const BottomSheetContent = styled.div`
  padding: 0 16px 40px 16px;
`;
